module.exports = __webpack_public_path__ + "static/basic_btn_somali-6ae6f3e0000193720c80.png";